// ChatPage.jsx
import React, { useEffect } from "react";
import ChatRoom from "../components/ChatRoom";
import "../styles/Chat.css";
import "../styles/mobile-chat.css";

const ChatPage = ({ onBack, setCurrentView }) => {
    useEffect(() => {
        const html = document.documentElement;
        const body = document.body;

        // اقفل تمرّج الصفحة نفسها
        html.classList.add("no-page-scroll");
        body.classList.add("no-page-scroll");

        const vv = window.visualViewport || null;

        const applyVV = () => {
            if (!vv) return;
            document.documentElement.style.setProperty("--vvh", `${vv.height}px`);
            document.documentElement.style.setProperty("--vv-top", `${vv.offsetTop}px`);
        };

        const keepTop = () => {
            const scroller = document.scrollingElement || document.documentElement;
            if (scroller.scrollTop !== 0) scroller.scrollTop = 0;
        };

        let onFocusIn = null;

        if (vv) {
            vv.addEventListener("resize", applyVV);
            vv.addEventListener("scroll", applyVV); // شريط العنوان يطلع/ينزل
            // window.addEventListener("scroll", keepTop, { passive: true });

            onFocusIn = (e) => {
                if (e.target.closest(".chat-page")) {
                    // امنع الصفحة من القفز وقت فتح الكيبورد
                    // requestAnimationFrame(keepTop);
                    requestAnimationFrame(applyVV);
                }
            };
            document.addEventListener("focusin", onFocusIn);

            applyVV();
        }

        return () => {
            if (vv) {
                vv.removeEventListener("resize", applyVV);
                vv.removeEventListener("scroll", applyVV);
            }
            // window.removeEventListener("scroll", keepTop);
            if (onFocusIn) document.removeEventListener("focusin", onFocusIn);

            document.documentElement.style.removeProperty("--vvh");
            document.documentElement.style.removeProperty("--vv-top");
            html.classList.remove("no-page-scroll");
            body.classList.remove("no-page-scroll");
        };
    }, []);


    return <ChatRoom onBack={onBack} setCurrentView={setCurrentView} />;
};

export default ChatPage;
